export default __webpack_public_path__ + "static/media/manomano-logo.32ca2404.png";